const replaceIdInPath = (pathname, prevId, nextId) => {
  const isFullUrl = /^https?:\/\//i.test(pathname);
  const url = isFullUrl ? new URL(pathname) : null;
  const pathOnly = isFullUrl ? url.pathname : pathname;

  // Split and keep leading slash by re-adding later
  const parts = pathOnly.split("/");

  // 1) Your original behavior: try exact prevId
  let i = parts.findIndex((p) => p === String(prevId));

  // 2) If not found, target the segment after known tokens
  if (i === -1) {
    const tokens = ["agent", "link-to-agent"];
    for (const t of tokens) {
      const j = parts.indexOf(t);
      if (j !== -1 && parts[j + 1]) {
        i = j + 1;
        break;
      }
    }
  }

  // 3) If still not found, replace the last segment that looks like an ID
  if (i === -1) {
    const UUID_RE =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    for (let k = parts.length - 1; k >= 0; k--) {
      if (UUID_RE.test(parts[k]) || /^\d+$/.test(parts[k])) {
        i = k;
        break;
      }
    }
  }

  if (i === -1) return null;

  parts[i] = String(nextId);

  const newPath = parts.join("/");
  if (isFullUrl) {
    return newPath + (url.search || "") + (url.hash || "");
  }
  return newPath;
};

export default replaceIdInPath;
